/*import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  // Se o token existir, permite o acesso à rota filha (Outlet).
  // Caso contrário, redireciona para a página de login.
  return userInfo && userInfo.token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
*/


import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');

  // Se o token existir, permite o acesso à rota filha (Outlet).
  // Caso contrário, redireciona para a página de login.
  if (!userInfo?.token)
    return <Navigate to="/login" replace />;

  if (!userInfo?.isAdmin)
    return <Navigate to="/" replace />;

  return <Outlet />;
};

export default ProtectedRoute;